/** A day in the UI language, without the time: „26 sierpnia 2026” / “August 26, 2026”. */
export const formatLongDate = (value: Date | string | number, language: string | null | undefined): string =>
  new Intl.DateTimeFormat(language?.startsWith('pl') ? 'pl-PL' : 'en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(value));
